import IActionsResolver from 'globx/dist/Store/Interfaces/IActionsResolver';
import merge            from 'helpful-merge';

import Config         from './Config';
import IConfig        from './Interfaces/IConfig';
import IConfigActions from './Interfaces/IConfigActions';

const resolveConfigActions: IActionsResolver<Config, IConfigActions> = (value: Config): IConfigActions => ({
    configure(nextOptions: IConfig): void {
        merge(value, nextOptions, true);
    }
});

export default resolveConfigActions;